import * as React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Divider,
  Chip,
} from "@mui/material";
import { Colors } from "../../utils/Colors";

const appointments = [
  {
    id: 1,
    patient: "Rahul Verma",
    time: "09:30 AM",
    type: "Follow-up",
    room: "Room 201",
  },
  {
    id: 2,
    patient: "Sneha Patel",
    time: "11:00 AM",
    type: "New Case",
    room: "Room 105",
  },
  {
    id: 3,
    patient: "Amit Joshi",
    time: "01:15 PM",
    type: "Review",
    room: "Room 305",
  },
];

export default function DoctorAppointments() {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.2,
        borderRadius: 4,
        bgcolor: Colors.bg.paper,
        border: `1px solid ${Colors.border.light}`,
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 800, color: Colors.text.title, mb: 2 }}
      >
        Today’s Appointments
      </Typography>

      <Stack spacing={1.5}>
        {appointments.map((item, index) => (
          <React.Fragment key={item.id}>
            <Box>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, color: Colors.text.title }}
                  >
                    {item.patient}
                  </Typography>
                  <Typography variant="body2" sx={{ color: Colors.text.muted, mt: 0.4 }}>
                    {item.time} • {item.room}
                  </Typography>
                </Box>

                <Chip
                  label={item.type}
                  size="small"
                  sx={{
                    bgcolor: Colors.bg.app,
                    color: Colors.brand.primary,
                    fontWeight: 700,
                  }}
                />
              </Stack>
            </Box>
            {index !== appointments.length - 1 && (
              <Divider sx={{ borderColor: Colors.border.light }} />
            )}
          </React.Fragment>
        ))}
      </Stack>
    </Paper>
  );
}